export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["robots.txt"]),
	mimeTypes: {".txt":"text/plain"},
	_: {
		client: {start:"_app/immutable/entry/start.Dyb3O7A7.js",app:"_app/immutable/entry/app.zmhUo-QN.js",imports:["_app/immutable/entry/start.Dyb3O7A7.js","_app/immutable/chunks/BREGS9Lr.js","_app/immutable/chunks/CKFcjP6K.js","_app/immutable/chunks/Af96Cbic.js","_app/immutable/chunks/DidpMcX_.js","_app/immutable/entry/app.zmhUo-QN.js","_app/immutable/chunks/CKFcjP6K.js","_app/immutable/chunks/DeAdfmry.js","_app/immutable/chunks/D0KpzAQe.js","_app/immutable/chunks/DidpMcX_.js","_app/immutable/chunks/Be555SGo.js","_app/immutable/chunks/C1G8G6MU.js","_app/immutable/chunks/B48Vnuib.js"],stylesheets:[],fonts:[],uses_env_dynamic_public:false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js')),
			__memo(() => import('./nodes/4.js')),
			__memo(() => import('./nodes/5.js')),
			__memo(() => import('./nodes/6.js')),
			__memo(() => import('./nodes/7.js')),
			__memo(() => import('./nodes/8.js')),
			__memo(() => import('./nodes/9.js')),
			__memo(() => import('./nodes/10.js')),
			__memo(() => import('./nodes/11.js')),
			__memo(() => import('./nodes/12.js')),
			__memo(() => import('./nodes/13.js')),
			__memo(() => import('./nodes/14.js')),
			__memo(() => import('./nodes/15.js')),
			__memo(() => import('./nodes/16.js')),
			__memo(() => import('./nodes/17.js'))
		],
		remotes: {
			'xxtqbu': __memo(() => import('./chunks/remote-xxtqbu.js'))
		},
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 6 },
				endpoint: null
			},
			{
				id: "/.well-known/cimd.json",
				pattern: /^\/\.well-known\/cimd\.json\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/.well-known/cimd.json/_server.ts.js'))
			},
			{
				id: "/auth/callback",
				pattern: /^\/auth\/callback\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/auth/callback/_server.ts.js'))
			},
			{
				id: "/auth/login",
				pattern: /^\/auth\/login\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/auth/login/_server.ts.js'))
			},
			{
				id: "/auth/logout",
				pattern: /^\/auth\/logout\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 7 },
				endpoint: null
			},
			{
				id: "/favicon.ico",
				pattern: /^\/favicon\.ico\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/favicon.ico/_server.ts.js'))
			},
			{
				id: "/servers",
				pattern: /^\/servers\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 8 },
				endpoint: null
			},
			{
				id: "/servers/[server]/databases",
				pattern: /^\/servers\/([^/]+?)\/databases\/?$/,
				params: [{"name":"server","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,2,], errors: [1,,], leaf: 9 },
				endpoint: null
			},
			{
				id: "/servers/[server]/databases/[database]/collections",
				pattern: /^\/servers\/([^/]+?)\/databases\/([^/]+?)\/collections\/?$/,
				params: [{"name":"server","optional":false,"rest":false,"chained":false},{"name":"database","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,2,3,], errors: [1,,,], leaf: 10 },
				endpoint: null
			},
			{
				id: "/servers/[server]/databases/[database]/collections/[collection]/documents",
				pattern: /^\/servers\/([^/]+?)\/databases\/([^/]+?)\/collections\/([^/]+?)\/documents\/?$/,
				params: [{"name":"server","optional":false,"rest":false,"chained":false},{"name":"database","optional":false,"rest":false,"chained":false},{"name":"collection","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,2,3,4,], errors: [1,,,,], leaf: 11 },
				endpoint: null
			},
			{
				id: "/servers/[server]/databases/[database]/collections/[collection]/documents/[document]",
				pattern: /^\/servers\/([^/]+?)\/databases\/([^/]+?)\/collections\/([^/]+?)\/documents\/([^/]+?)\/?$/,
				params: [{"name":"server","optional":false,"rest":false,"chained":false},{"name":"database","optional":false,"rest":false,"chained":false},{"name":"collection","optional":false,"rest":false,"chained":false},{"name":"document","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,2,3,4,5,], errors: [1,,,,,], leaf: 12 },
				endpoint: null
			},
			{
				id: "/servers/[server]/databases/[database]/collections/[collection]/indexes",
				pattern: /^\/servers\/([^/]+?)\/databases\/([^/]+?)\/collections\/([^/]+?)\/indexes\/?$/,
				params: [{"name":"server","optional":false,"rest":false,"chained":false},{"name":"database","optional":false,"rest":false,"chained":false},{"name":"collection","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,2,3,4,], errors: [1,,,,], leaf: 13 },
				endpoint: null
			},
			{
				id: "/servers/[server]/databases/[database]/collections/[collection]/mappings",
				pattern: /^\/servers\/([^/]+?)\/databases\/([^/]+?)\/collections\/([^/]+?)\/mappings\/?$/,
				params: [{"name":"server","optional":false,"rest":false,"chained":false},{"name":"database","optional":false,"rest":false,"chained":false},{"name":"collection","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,2,3,4,], errors: [1,,,,], leaf: 14 },
				endpoint: null
			},
			{
				id: "/servers/[server]/databases/[database]/collections/[collection]/schema",
				pattern: /^\/servers\/([^/]+?)\/databases\/([^/]+?)\/collections\/([^/]+?)\/schema\/?$/,
				params: [{"name":"server","optional":false,"rest":false,"chained":false},{"name":"database","optional":false,"rest":false,"chained":false},{"name":"collection","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,2,3,4,], errors: [1,,,,], leaf: 15 },
				endpoint: null
			},
			{
				id: "/servers/[server]/databases/[database]/collections/[collection]/sharding",
				pattern: /^\/servers\/([^/]+?)\/databases\/([^/]+?)\/collections\/([^/]+?)\/sharding\/?$/,
				params: [{"name":"server","optional":false,"rest":false,"chained":false},{"name":"database","optional":false,"rest":false,"chained":false},{"name":"collection","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,2,3,4,], errors: [1,,,,], leaf: 16 },
				endpoint: null
			},
			{
				id: "/servers/[server]/users",
				pattern: /^\/servers\/([^/]+?)\/users\/?$/,
				params: [{"name":"server","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,], errors: [1,], leaf: 17 },
				endpoint: null
			}
		],
		prerendered_routes: new Set([]),
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set([]);

export const base = "";